import type { Limit } from 'types/paymentLimits'

export const LIMIT_TYPE_LABELS = {
  TRANSACTION: 'paymentLimits.transactionLimit',
  DAILY: 'paymentLimits.dailyLimit',
} satisfies Record<Limit['limitType'], string>

const PAYMENT_METHOD_LABELS: Record<string, string> = {
  SEPA_CT: 'SEPA',
  SEPA_INST: 'SEPA Instant',
  SWIFT: 'SWIFT',
  FASTER_PAYMENTS: 'Faster Payments',
  ACH: 'ACH',
  FEDWIRE: 'Fedwire',
  FEDNOW: 'FedNow',
  CRNOW: 'CRNow',
  RTP: 'RTP',
}

export const formatPaymentMethodLabel = (method: string): string => {
  return PAYMENT_METHOD_LABELS[method] ?? method.replaceAll('_', ' ')
}
